module.exports = __webpack_public_path__ + "img/reveal-deal-unlock-neutral-gif.6f2c0c3c.gif";